import { Grid } from '@material-ui/core';
import React, { useEffect } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';

import './Checkout.css';

export default function IfraneDesktop() {
  const navigate = useNavigate();
  const location = useLocation();

  useEffect(() => {
    if (location.state) {
      (window as any).UIWidget.InitUi(location.state);
    } else if (location.search) {
      window?.sessionStorage.removeItem('externalOrderId');
      window?.sessionStorage.removeItem('senseKey');
      const searchParams = new URLSearchParams(location.search);
      const orderId = searchParams.get('orderId');
      const size = searchParams.get('size');
      if (orderId && size) {
        (window as any).fc.setOrderId({ orderId, size });
        (window as any).UIWidget.InitUi({ container: 'iframe-container' });
      }
    }
  }, []);

  return (
    <div className="ItemDetails">
      <Grid container className="container">
        <Grid item xs={12} sm={12} className="content">
          <div id="iframe-container" />
        </Grid>
      </Grid>
    </div>
  );
}
